import {createAction} from "redux-act";
import {EventStatus, RoundStatus} from "modules/enums";

export interface ICourse {
	name: string;
	city: string;
	country: string;
}

export interface IRound  {
	id: number;
	roundNum: number;
	isFinished: boolean;
	dateStart: string | null;
	dateEnd: string | null;
	status: RoundStatus;
}

export interface IEvent {
	id: number;
	name: string;
	dateStart: string;
	dateEnd: string;
	isMajor: boolean;
	isWgc: boolean;
	isMatchPlay: boolean;
	fieldSize?: number;
	country: string;
	status: EventStatus;
	courses?: ICourse[];
	rounds?: IRound[];
	hasRounds?: boolean;
}

export interface IEventWithPrevNext extends IEvent {
	prevEvent: IEvent | null;
	nextEvent: IEvent | null;
}

export const requestEventsJSON = createAction();
export const requestEventsJSONSuccess = createAction<IEvent[]>();
export const requestEventsJSONFailed = createAction();

export const setViewedEventID = createAction<number | null>();
export const switchEventStatusToLive = createAction<number>();
